import { render, staticRenderFns } from "./PersonDialogAddressTabComponent.vue?vue&type=template&id=32467bc4&scoped=true"
import script from "./PersonDialogAddressTabComponent.js?vue&type=script&lang=js&external"
export * from "./PersonDialogAddressTabComponent.js?vue&type=script&lang=js&external"
import style0 from "./PersonDialogAddressTabComponent.vue?vue&type=style&index=0&id=32467bc4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32467bc4",
  null
  
)

export default component.exports